import React from "react";
import DateTimeSelector from "@tripbuilder/cat-transport/right/customTransportComponents/dateTimeComp";
import useTripStore from "@/stores/tripBuilder/useTrip";

interface TimeStepProps {
  checkInTime: string;
  checkOutTime: string;
  onCheckInTimeChange: (time: string) => void;
  onCheckOutTimeChange: (time: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

const TimeStep: React.FC<TimeStepProps> = ({
  checkInTime,
  checkOutTime,
  onCheckInTimeChange,
  onCheckOutTimeChange,
  onKeyDown,
}) => {
  const { selectedLocation } = useTripStore();

  return (
    <div className="grid grid-cols-2 gap-4" onKeyDown={onKeyDown}>
      <div className="space-y-2">
        <DateTimeSelector
          selectedDate={checkInTime}
          onDateSelect={onCheckInTimeChange}
          label="Check-in Time"
          targetZone={selectedLocation?.date.time_zone || "UTC"}
          hideDate={true}
          baseDate={selectedLocation?.date.start_date}
        />
      </div>
      <div className="space-y-2">
        <DateTimeSelector
          selectedDate={checkOutTime}
          onDateSelect={onCheckOutTimeChange}
          label="Check-out Time"
          targetZone={selectedLocation?.date.time_zone || "UTC"}
          hideDate={true}
          baseDate={selectedLocation?.date.end_date}
        />
      </div>
    </div>
  );
};

export default TimeStep;
